module.exports = __webpack_public_path__ + "static/media/typescript.54a24310.png";